import { when } from '@execonline-inc/maybe-adapter';
import { fromEmpty, Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { previewStore } from '../LearningCollectionPreviewStore';
import { PreviewState } from '../LearningCollectionPreviewStore/Types';
import AddInternalName from './AddInternalName';
import InternalTextField from './InternalTextField';
import ShowInternalName from './ShowInternalName';

type StateWithInternalName = Extract<PreviewState, { internalName: Maybe<string> }>;

function InternalName() {
  const [isTextField, setIsTextField] = useState<boolean>(false);

  const addInternalName = (value: string) => {
    previewStore.addInternalName(value);
  };

  const handleFieldHide = () => {
    setIsTextField(false);
  };

  const handleFieldShow = () => {
    setIsTextField(true);
  };

  const hasInternalName = (state: PreviewState): state is StateWithInternalName => {
    return 'internalName' in state;
  };

  const interNameValue = (): string =>
    hasInternalName(previewStore.state) ? previewStore.state.internalName.getOrElseValue('') : '';

  return (
    <div className="flex flex-row items-center pb-2 w-2/3 h-[25px] mt-2">
      {when(isTextField, true)
        .map(() => (
          <InternalTextField
            internalNameValue={interNameValue()}
            onFieldHide={handleFieldHide}
            addInternalName={addInternalName}
          />
        ))
        .orElse(() =>
          fromEmpty(interNameValue()).map((internalName) => (
            <ShowInternalName internalName={internalName} onFieldShow={handleFieldShow} />
          )),
        )
        .getOrElse(() => (
          <AddInternalName onFieldShow={handleFieldShow} />
        ))}
    </div>
  );
}

export default observer(InternalName);
